module.exports = "<div *ngIf=\"success\" class=\"alert alert-success alert-message\" [innerHtml]=\"message\"></div>\n<div *ngIf=\"error\" class=\"alert alert-danger alert-message\" [innerHtml]=\"message\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/alert-message/alert-message.component.html
// module id = 566
// module chunks = 0